"use strict";
/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
// TODO AB#7377 Provide Fluid EventEmitter using support in packages/dds/tree/src/events.
var events_pkg_1 = require("events_pkg");
Object.defineProperty(exports, "EventEmitter", { enumerable: true, get: function () { return events_pkg_1.EventEmitter; } });
//# sourceMappingURL=eventEmitter.cjs.map